export const grade10Part2 = [
  {
    id: 'g10-transformations-reflections',
    title: 'Reflections and Line Symmetry',
    topic: 'Transformations & Congruence',
    standard: 'CCSS.MATH.CONTENT.HSG.CO.A.4',
    difficulty: 'medium',
    questions: [
      {
        id: 1,
        question: 'Point P(3, 5) is reflected across the x-axis. What are the coordinates of P\'?',
        options: ['(3, -5)', '(-3, 5)', '(-3, -5)', '(5, 3)'],
        correctAnswer: 0,
        solution: 'Reflection across x-axis: (x, y) → (x, -y)\n\nP(3, 5) → P\'(3, -5)\n\nThe x-coordinate stays the same, y-coordinate changes sign.'
      },
      {
        id: 2,
        question: 'Point Q(-2, 4) is reflected across the y-axis. What are the coordinates of Q\'?',
        options: ['(2, 4)', '(-2, -4)', '(2, -4)', '(4, -2)'],
        correctAnswer: 0,
        solution: 'Reflection across y-axis: (x, y) → (-x, y)\n\nQ(-2, 4) → Q\'(2, 4)\n\nThe y-coordinate stays the same, x-coordinate changes sign.'
      },
      {
        id: 3,
        question: 'Point M(4, 3) is reflected across the line y = x. What are the coordinates of M\'?',
        options: ['(3, 4)', '(-4, -3)', '(4, -3)', '(-3, 4)'],
        correctAnswer: 0,
        solution: 'Reflection across y = x: (x, y) → (y, x)\n\nM(4, 3) → M\'(3, 4)\n\nThe coordinates are swapped.'
      },
      {
        id: 4,
        question: 'Which transformation reverses orientation?',
        options: ['Reflection', 'Translation', 'Rotation', 'All of the above'],
        correctAnswer: 0,
        solution: 'Orientation-reversing transformations:\n• Reflections ✓\n• Glide reflections ✓\n\nOrientation-preserving transformations:\n• Translations\n• Rotations\n\nReflections flip figures, reversing their orientation.'
      },
      {
        id: 5,
        question: 'A rectangle has how many lines of symmetry?',
        options: ['2', '4', '1', '0'],
        correctAnswer: 0,
        solution: 'Rectangle (not square) has 2 lines of symmetry:\n1. Horizontal line through center\n2. Vertical line through center\n\nNote: Diagonals are NOT lines of symmetry for rectangles.\n\nSquares have 4 lines of symmetry.'
      },
      {
        id: 6,
        question: 'Point A is reflected across line ℓ to point A\'. What is the relationship between line ℓ and segment AA\'?',
        options: ['ℓ is perpendicular bisector of AA\'', 'ℓ is parallel to AA\'', 'ℓ passes through midpoint only', 'No special relationship'],
        correctAnswer: 0,
        solution: 'Properties of reflection:\n• Line of reflection is perpendicular to segment connecting point and image\n• Line of reflection bisects this segment\n\nTherefore: ℓ ⊥ AA\' and ℓ bisects AA\'\n\nℓ is the perpendicular bisector of AA\'.'
      },
      {
        id: 7,
        question: 'Triangle ABC is reflected across the y-axis. If A is at (2, 3), B is at (5, 1), where is A\'?',
        options: ['(-2, 3)', '(2, -3)', '(-2, -3)', '(-5, -1)'],
        correctAnswer: 0,
        solution: 'Reflection across y-axis: (x, y) → (-x, y)\n\nA(2, 3) → A\'(-2, 3)\n\nOnly the x-coordinate changes sign.'
      },
      {
        id: 8,
        question: 'Point P(a, b) is reflected across the origin. What are the coordinates of P\'?',
        options: ['(-a, -b)', '(b, a)', '(-b, -a)', '(a, -b)'],
        correctAnswer: 0,
        solution: 'Reflection across the origin = 180° rotation about origin\n\n(x, y) → (-x, -y)\n\nP(a, b) → P\'(-a, -b)\n\nBoth coordinates change sign.'
      },
      {
        id: 9,
        question: 'Which letter has exactly one line of symmetry?',
        options: ['A', 'H', 'O', 'Z'],
        correctAnswer: 0,
        solution: 'Lines of symmetry:\n• A: 1 (vertical)\n• H: 2 (horizontal and vertical)\n• O: infinite (any diameter)\n• Z: 0 (but has 180° rotational symmetry)\n\nA has exactly one line of symmetry.'
      },
      {
        id: 10,
        question: 'A figure is reflected across line m, then reflected across line m again. What is the result?',
        options: ['Identity (original position)', 'Translation', '180° rotation', 'Different reflection'],
        correctAnswer: 0,
        solution: 'Double reflection across the same line:\n\nFirst reflection: P → P\'\nSecond reflection: P\' → P\n\nResult: Identity transformation\n\nReflecting twice across the same line returns every point to its original position.'
      },
      {
        id: 11,
        question: 'Point K(6, -2) is reflected across the line y = -x. What are the coordinates of K\'?',
        options: ['(2, -6)', '(-6, 2)', '(6, 2)', '(-2, 6)'],
        correctAnswer: 0,
        solution: 'Reflection across y = -x: (x, y) → (-y, -x)\n\nK(6, -2) → K\'(2, -6)\n\nSwap coordinates and change both signs.'
      },
      {
        id: 12,
        question: 'An isosceles triangle has how many lines of symmetry?',
        options: ['1', '2', '3', '0'],
        correctAnswer: 0,
        solution: 'Isosceles triangle (not equilateral):\n• One line of symmetry through the vertex angle and midpoint of base\n\nEquilateral triangle: 3 lines of symmetry\nScalene triangle: 0 lines of symmetry\n\nIsosceles has exactly 1 line of symmetry.'
      },
      {
        id: 13,
        question: 'Line segment AB is reflected across line ℓ. If AB = 8 cm, what is A\'B\'?',
        options: ['8 cm', '16 cm', '4 cm', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Reflections are rigid motions (isometries).\n\nRigid motions preserve:\n• All distances\n• All lengths\n• All angle measures\n\nA\'B\' = AB = 8 cm'
      },
      {
        id: 14,
        question: 'A figure is reflected across line ℓ₁, then across parallel line ℓ₂. What single transformation is equivalent?',
        options: ['Translation', 'Rotation', 'Reflection', 'Dilation'],
        correctAnswer: 0,
        solution: 'Two reflections across parallel lines = Translation\n\nTranslation distance = 2 × (distance between lines)\nTranslation direction = perpendicular to the lines\n\nThis is a fundamental theorem of transformations.'
      },
      {
        id: 15,
        question: 'Point M is on line ℓ. When M is reflected across ℓ, where is M\'?',
        options: ['Same as M', 'Opposite side of ℓ', 'Cannot determine', 'At origin'],
        correctAnswer: 0,
        solution: 'Points ON the line of reflection are fixed points.\n\nIf M is on line ℓ, then M\' = M\n\nThe line of reflection is invariant under the reflection.\n\nAll points on ℓ map to themselves.'
      },
      {
        id: 16,
        question: 'Triangle PQR is reflected across the x-axis. If ∠P = 50°, what is ∠P\'?',
        options: ['50°', '130°', '40°', '100°'],
        correctAnswer: 0,
        solution: 'Reflections preserve angle measures.\n\n∠P\' = ∠P = 50°\n\nReflections are isometries that preserve:\n• Distances\n• Angles\n• Areas\n• Shapes'
      },
      {
        id: 17,
        question: 'A regular pentagon has how many lines of symmetry?',
        options: ['5', '10', '0', '1'],
        correctAnswer: 0,
        solution: 'Regular n-gon has n lines of symmetry.\n\nRegular pentagon: 5 lines of symmetry\n• Each line passes through a vertex and the midpoint of the opposite side\n\nRegular n-gon has n lines of symmetry.'
      },
      {
        id: 18,
        question: 'Point A(3, 4) is reflected across the x-axis, then the image is reflected across the y-axis. What are the final coordinates?',
        options: ['(-3, -4)', '(3, 4)', '(-3, 4)', '(3, -4)'],
        correctAnswer: 0,
        solution: 'First reflection (x-axis): (3, 4) → (3, -4)\nSecond reflection (y-axis): (3, -4) → (-3, -4)\n\nAlternatively: Two perpendicular axis reflections = 180° rotation about origin\n(x, y) → (-x, -y)'
      },
      {
        id: 19,
        question: 'Which figure has NO lines of symmetry but HAS rotational symmetry?',
        options: ['Parallelogram', 'Rectangle', 'Isosceles triangle', 'Regular hexagon'],
        correctAnswer: 0,
        solution: 'Parallelogram (not rectangle):\n• Lines of symmetry: 0\n• Rotational symmetry: 180° (order 2)\n\nRectangle: 2 lines of symmetry\nIsosceles triangle: 1 line of symmetry\nRegular hexagon: 6 lines of symmetry\n\nParallelogram has rotational but not reflectional symmetry.'
      },
      {
        id: 20,
        question: 'A circle is reflected across any line through its center. What is true about the image?',
        options: ['Coincides with original', 'Is translated', 'Is larger', 'Is rotated'],
        correctAnswer: 0,
        solution: 'A circle has infinite lines of symmetry.\n\nAny line through the center is a line of symmetry.\n\nReflecting across any diameter produces the same circle.\n\nThe image coincides with the original.'
      },
      {
        id: 21,
        question: 'Point P is 5 units from line ℓ. After reflection across ℓ, how far is P\' from ℓ?',
        options: ['5 units', '10 units', '2.5 units', '0 units'],
        correctAnswer: 0,
        solution: 'Reflection property:\nDistance from point to line = Distance from image to line\n\nIf P is 5 units from ℓ, then P\' is 5 units from ℓ (on opposite side)\n\nThe line of reflection is equidistant from P and P\'.'
      },
      {
        id: 22,
        question: 'A figure is reflected across intersecting lines ℓ₁ and ℓ₂ that form a 40° angle. What single transformation is equivalent?',
        options: ['80° rotation', '40° rotation', '20° rotation', 'Translation'],
        correctAnswer: 0,
        solution: 'Two reflections across intersecting lines = Rotation\n\nRotation angle = 2 × (angle between lines)\nRotation center = intersection point\n\n2 × 40° = 80° rotation\n\nThis is a fundamental theorem of transformations.'
      },
      {
        id: 23,
        question: 'Quadrilateral ABCD is reflected across line m. Which statement is TRUE?',
        options: ['A\'B\'C\'D\' ≅ ABCD', 'A\'B\'C\'D\' ~ ABCD but not ≅', 'Area doubles', 'Perimeter doubles'],
        correctAnswer: 0,
        solution: 'Reflections are rigid motions (isometries).\n\nIsometries produce congruent figures:\nA\'B\'C\'D\' ≅ ABCD\n\nSame size, same shape, just reflected orientation.'
      },
      {
        id: 24,
        question: 'Point M(0, 7) is reflected across the x-axis. What are the coordinates of M\'?',
        options: ['(0, -7)', '(7, 0)', '(-7, 0)', '(0, 7)'],
        correctAnswer: 0,
        solution: 'Reflection across x-axis: (x, y) → (x, -y)\n\nM(0, 7) → M\'(0, -7)\n\nPoints on the y-axis stay on the y-axis when reflected across x-axis.'
      },
      {
        id: 25,
        question: 'An equilateral triangle has how many lines of symmetry?',
        options: ['3', '6', '1', '0'],
        correctAnswer: 0,
        solution: 'Equilateral triangle has 3 lines of symmetry:\n• Each line passes through a vertex and the midpoint of the opposite side\n• These are also the angle bisectors, medians, and altitudes\n\nRegular n-gon has n lines of symmetry.'
      },
      {
        id: 26,
        question: 'Line ℓ has equation y = 2x + 1. Point P(1, 3) is reflected across the x-axis. Does P\' lie on ℓ?',
        options: ['Yes', 'No', 'Cannot determine', 'Only if ℓ is horizontal'],
        correctAnswer: 1,
        solution: 'P(1, 3) reflected across x-axis: P\'(1, -3)\n\nCheck if P\' is on y = 2x + 1:\ny = 2(1) + 1 = 3\n\nBut P\' has y = -3 ≠ 3\n\nTherefore, P\' does NOT lie on ℓ.'
      },
      {
        id: 27,
        question: 'A scalene triangle has how many lines of symmetry?',
        options: ['0', '1', '2', '3'],
        correctAnswer: 0,
        solution: 'Scalene triangle: all sides different lengths\n\nLines of symmetry: 0\n\nTriangle symmetries:\n• Scalene: 0 lines\n• Isosceles: 1 line\n• Equilateral: 3 lines'
      },
      {
        id: 28,
        question: 'Rectangle PQRS has vertices P(1, 2), Q(5, 2), R(5, 6), S(1, 6). What is the equation of a line of symmetry?',
        options: ['x = 3', 'y = 3', 'x = 4', 'Both x = 3 and y = 4'],
        correctAnswer: 3,
        solution: 'Rectangle center: ((1+5)/2, (2+6)/2) = (3, 4)\n\nLines of symmetry pass through center:\n• Vertical: x = 3\n• Horizontal: y = 4\n\nBoth x = 3 and y = 4 are lines of symmetry.'
      },
      {
        id: 29,
        question: 'Point A is reflected across line ℓ to get A\', then A\' is reflected across line m (parallel to ℓ) to get A". If the distance between ℓ and m is 4 units, what is the distance AA"?',
        options: ['8 units', '4 units', '16 units', 'Cannot determine'],
        correctAnswer: 0,
        solution: 'Two reflections across parallel lines = Translation\n\nTranslation distance = 2 × (distance between lines)\n= 2 × 4 = 8 units\n\nAA" = 8 units (perpendicular to the lines)'
      },
      {
        id: 30,
        question: 'Which transformation is its own inverse?',
        options: ['Reflection', 'Translation', 'Rotation 90°', 'All transformations'],
        correctAnswer: 0,
        solution: 'Reflection is its own inverse:\nReflecting twice across the same line returns to original position.\n\nTranslation: inverse is opposite translation\nRotation 90°: inverse is rotation -90° (or 270°)\n\nOnly reflections and 180° rotations are self-inverse.'
      }
    ]
  },
  {
    id: 'g10-constructions-basic',
    title: 'Geometric Constructions with Compass and Straightedge',
    topic: 'Constructions',
    standard: 'CCSS.MATH.CONTENT.HSG.CO.D.12',
    difficulty: 'medium',
    questions: [
      {
        id: 1,
        question: 'To construct a perpendicular bisector of segment AB, what is the first step?',
        options: ['Open compass wider than half of AB', 'Draw a line through A', 'Find the midpoint', 'Draw a circle with center A'],
        correctAnswer: 0,
        solution: 'Perpendicular bisector construction:\n1. Open compass MORE than half the length of AB\n2. Place compass at A, draw arc above and below AB\n3. Keep same radius, place compass at B, draw arcs intersecting previous arcs\n4. Connect intersection points\n\nThe compass must be wider than half AB to ensure arcs intersect.'
      },
      {
        id: 2,
        question: 'Which construction requires drawing two circles with the same radius?',
        options: ['Perpendicular bisector', 'Angle bisector', 'Parallel line', 'Perpendicular at a point'],
        correctAnswer: 0,
        solution: 'Perpendicular bisector construction:\n• Draw circle centered at A with radius > AB/2\n• Draw circle centered at B with SAME radius\n• Connect intersection points\n\nThe equal radii ensure the construction is symmetric.'
      },
      {
        id: 3,
        question: 'To bisect an angle, where should you place the compass first?',
        options: ['At the vertex', 'On one ray', 'On the other ray', 'At any point'],
        correctAnswer: 0,
        solution: 'Angle bisector construction:\n1. Place compass at vertex V\n2. Draw arc intersecting both rays at points P and Q\n3. Place compass at P, draw arc in interior\n4. Place compass at Q (same radius), draw arc intersecting previous arc\n5. Draw ray from V through intersection\n\nAlways start at the vertex.'
      },
      {
        id: 4,
        question: 'What is the minimum number of arcs needed to construct a perpendicular bisector?',
        options: ['4', '2', '3', '6'],
        correctAnswer: 0,
        solution: 'Perpendicular bisector requires:\n• 2 arcs from point A (above and below)\n• 2 arcs from point B (above and below)\n\nTotal: 4 arcs minimum\n\nThese 4 arcs create 2 intersection points that define the perpendicular bisector.'
      },
      {
        id: 5,
        question: 'To construct a line parallel to line ℓ through point P (not on ℓ), which construction is used?',
        options: ['Copy an angle', 'Bisect an angle', 'Construct perpendicular', 'Construct midpoint'],
        correctAnswer: 0,
        solution: 'Parallel line construction method:\n1. Draw transversal through P intersecting ℓ\n2. Copy the angle formed at ℓ to point P\n3. Corresponding angles are equal → lines are parallel\n\nAlternatively: Construct two perpendiculars (perpendicular to perpendicular = parallel)'
      },
      {
        id: 6,
        question: 'Which tool is NOT allowed in classical geometric constructions?',
        options: ['Protractor', 'Compass', 'Straightedge', 'Pencil'],
        correctAnswer: 0,
        solution: 'Classical (Euclidean) constructions allow ONLY:\n✓ Compass (for circles and arcs)\n✓ Straightedge (for lines, no measurements)\n\n✗ Protractor (measures angles)\n✗ Ruler (measures distances)\n\nConstructions must be done without measurements.'
      },
      {
        id: 7,
        question: 'To construct a perpendicular to line ℓ at point P on ℓ, what is the key step?',
        options: ['Draw equal arcs on both sides of P', 'Draw a circle through P', 'Copy an angle', 'Bisect a segment'],
        correctAnswer: 0,
        solution: 'Perpendicular at a point construction:\n1. Place compass at P\n2. Draw arcs intersecting ℓ at points A and B (equal distances from P)\n3. Open compass wider\n4. Draw arcs from A and B on same side of ℓ\n5. Connect P to intersection point\n\nEqual arcs ensure perpendicularity.'
      },
      {
        id: 8,
        question: 'What geometric principle ensures that the perpendicular bisector construction works?',
        options: ['Points equidistant from endpoints lie on perpendicular bisector', 'Vertical angles are equal', 'Parallel lines never meet', 'Sum of angles is 180°'],
        correctAnswer: 0,
        solution: 'Perpendicular Bisector Theorem:\nAny point equidistant from two points lies on the perpendicular bisector.\n\nConstruction creates points equidistant from A and B (using equal compass radii).\n\nThese points define the perpendicular bisector.'
      },
      {
        id: 9,
        question: 'To construct a 60° angle, what is the most efficient method?',
        options: ['Construct equilateral triangle', 'Bisect 120° angle', 'Copy from protractor', 'Trisect 180° angle'],
        correctAnswer: 0,
        solution: 'Constructing 60° angle:\n1. Draw ray from point A\n2. Place compass at A, draw arc intersecting ray at B\n3. Keep same radius, place compass at B, draw arc intersecting first arc at C\n4. Draw ray from A through C\n\nThis creates equilateral triangle → all angles are 60°.'
      },
      {
        id: 10,
        question: 'Which angle CANNOT be constructed with compass and straightedge alone?',
        options: ['20°', '45°', '60°', '90°'],
        correctAnswer: 0,
        solution: 'Constructible angles:\n✓ 90° (perpendicular)\n✓ 60° (equilateral triangle)\n✓ 45° (bisect 90°)\n✓ 30° (bisect 60°)\n✓ 15° (bisect 30°)\n\n✗ 20° (requires trisecting 60°, which is impossible)\n\nAngle trisection is one of the three impossible constructions.'
      },
      {
        id: 11,
        question: 'To construct the incenter of a triangle, you must construct:',
        options: ['Three angle bisectors', 'Three perpendicular bisectors', 'Three medians', 'Three altitudes'],
        correctAnswer: 0,
        solution: 'Triangle centers:\n• Incenter: intersection of angle bisectors (center of inscribed circle)\n• Circumcenter: intersection of perpendicular bisectors\n• Centroid: intersection of medians\n• Orthocenter: intersection of altitudes\n\nIncenter requires angle bisectors.'
      },
      {
        id: 12,
        question: 'What is the first step to construct a square?',
        options: ['Construct perpendicular lines', 'Draw a circle', 'Bisect an angle', 'Copy a segment'],
        correctAnswer: 0,
        solution: 'Square construction:\n1. Construct two perpendicular lines (90° angles)\n2. Mark equal distances on all four rays from intersection\n3. Connect the four points\n\nPerpendicular lines ensure right angles.\nEqual distances ensure equal sides.'
      },
      {
        id: 13,
        question: 'To construct a regular hexagon inscribed in a circle, what is the key property?',
        options: ['Side length equals radius', 'Side length equals diameter', 'Side length equals half radius', 'Side length equals circumference/6'],
        correctAnswer: 0,
        solution: 'Regular hexagon inscribed in circle:\nSide length = radius\n\nConstruction:\n1. Draw circle with center O\n2. Mark point A on circle\n3. Keep same radius, place compass at A, mark point B on circle\n4. Continue around circle\n5. Connect six points\n\nThis works because 360°/6 = 60° and creates equilateral triangles.'
      },
      {
        id: 14,
        question: 'Which construction is used to find the center of a given circle?',
        options: ['Two perpendicular bisectors of chords', 'One diameter', 'Three tangent lines', 'Angle bisector'],
        correctAnswer: 0,
        solution: 'Finding center of circle:\n1. Draw any two chords\n2. Construct perpendicular bisector of each chord\n3. Intersection point is the center\n\nPerpendicular bisectors of chords always pass through the center.\n\nTwo bisectors are sufficient to locate the center.'
      },
      {
        id: 15,
        question: 'To construct a tangent to a circle from an external point P, what must you construct first?',
        options: ['Connect P to center O', 'Draw perpendicular at P', 'Bisect angle at P', 'Draw circle through P'],
        correctAnswer: 0,
        solution: 'Tangent from external point construction:\n1. Connect P to center O\n2. Construct perpendicular bisector of PO (finds midpoint M)\n3. Draw circle with center M and radius MO (or MP)\n4. This circle intersects original circle at tangent points\n5. Connect P to tangent points\n\nTangent is perpendicular to radius at point of tangency.'
      },
      {
        id: 16,
        question: 'What is the minimum number of circles needed to construct an equilateral triangle?',
        options: ['2', '1', '3', '4'],
        correctAnswer: 0,
        solution: 'Equilateral triangle construction:\n1. Draw segment AB\n2. Draw circle centered at A with radius AB\n3. Draw circle centered at B with radius AB (same radius)\n4. Circles intersect at point C\n5. Connect A-C and B-C\n\nMinimum: 2 circles\n\nThe intersection point is equidistant from A and B.'
      },
      {
        id: 17,
        question: 'To construct a 45° angle, which angle should you bisect?',
        options: ['90°', '60°', '180°', '120°'],
        correctAnswer: 0,
        solution: 'Constructing 45° angle:\n1. Construct 90° angle (perpendicular)\n2. Bisect the 90° angle\n3. Result: 45° angle\n\n90° ÷ 2 = 45°\n\nAlternatively: Bisect a right angle in a square.'
      },
      {
        id: 18,
        question: 'Which point of concurrency is constructed using perpendicular bisectors?',
        options: ['Circumcenter', 'Incenter', 'Centroid', 'Orthocenter'],
        correctAnswer: 0,
        solution: 'Triangle centers and their constructions:\n• Circumcenter: perpendicular bisectors (center of circumscribed circle)\n• Incenter: angle bisectors (center of inscribed circle)\n• Centroid: medians (center of mass)\n• Orthocenter: altitudes (intersection of heights)\n\nCircumcenter uses perpendicular bisectors.'
      },
      {
        id: 19,
        question: 'To construct a line perpendicular to line ℓ through point P NOT on ℓ, what is the key step?',
        options: ['Draw arc from P intersecting ℓ at two points', 'Draw line through P parallel to ℓ', 'Bisect angle at P', 'Copy angle to P'],
        correctAnswer: 0,
        solution: 'Perpendicular from external point:\n1. Place compass at P\n2. Draw arc intersecting ℓ at two points A and B\n3. Draw arcs from A and B on opposite side of ℓ from P\n4. Connect P to intersection point\n\nThis creates a perpendicular through P to ℓ.'
      },
      {
        id: 20,
        question: 'What is the purpose of using a compass in geometric constructions?',
        options: ['Transfer distances and draw circles', 'Measure angles', 'Draw straight lines', 'Measure lengths'],
        correctAnswer: 0,
        solution: 'Compass functions in constructions:\n✓ Draw circles and arcs\n✓ Transfer distances (copy lengths)\n✓ Mark equal distances\n\n✗ Cannot measure angles\n✗ Cannot draw straight lines\n✗ Cannot measure lengths (no scale)\n\nCompass preserves distances without measuring.'
      },
      {
        id: 21,
        question: 'To construct a 30° angle, which construction should you perform?',
        options: ['Bisect a 60° angle', 'Trisect a 90° angle', 'Bisect a 45° angle', 'Copy a 30° angle'],
        correctAnswer: 0,
        solution: 'Constructing 30° angle:\n1. Construct 60° angle (equilateral triangle)\n2. Bisect the 60° angle\n3. Result: 30° angle\n\n60° ÷ 2 = 30°\n\nNote: Cannot trisect 90° with compass and straightedge.'
      },
      {
        id: 22,
        question: 'Which construction creates a point equidistant from three given points?',
        options: ['Circumcenter', 'Incenter', 'Centroid', 'Orthocenter'],
        correctAnswer: 0,
        solution: 'Circumcenter properties:\n• Equidistant from all three vertices\n• Center of circumscribed circle\n• Intersection of perpendicular bisectors\n\nConstruction: Draw perpendicular bisectors of any two sides.\n\nCircumcenter is equidistant from all three vertices.'
      },
      {
        id: 23,
        question: 'To construct a regular pentagon, which method is most practical?',
        options: ['Use 72° angles', 'Bisect angles repeatedly', 'Use equilateral triangles', 'Trisect angles'],
        correctAnswer: 0,
        solution: 'Regular pentagon:\n• Central angle: 360° ÷ 5 = 72°\n• Interior angle: 108°\n\nConstruction requires constructing 72° angles, which involves more complex methods (golden ratio).\n\nPentagon construction is possible but complex with compass and straightedge.'
      },
      {
        id: 24,
        question: 'What does it mean for a construction to be "impossible" with compass and straightedge?',
        options: ['Cannot be done in finite steps', 'Takes too many steps', 'Requires protractor', 'Requires calculator'],
        correctAnswer: 0,
        solution: 'Three impossible constructions:\n1. Trisecting an arbitrary angle\n2. Doubling the cube (constructing ∛2)\n3. Squaring the circle (constructing √π)\n\nThese are proven mathematically impossible with only compass and straightedge in finite steps.\n\nProven by Galois theory and transcendental numbers.'
      },
      {
        id: 25,
        question: 'To construct the centroid of a triangle, you must construct:',
        options: ['Three medians', 'Three angle bisectors', 'Three perpendicular bisectors', 'Three altitudes'],
        correctAnswer: 0,
        solution: 'Centroid construction:\n1. Construct midpoint of each side (perpendicular bisector)\n2. Connect each vertex to opposite midpoint (median)\n3. Intersection of medians is the centroid\n\nCentroid divides each median in ratio 2:1 from vertex.\n\nCentroid is the center of mass.'
      },
      {
        id: 26,
        question: 'Which construction requires finding the midpoint of a segment?',
        options: ['All of the above', 'Perpendicular bisector', 'Median of triangle', 'Centroid'],
        correctAnswer: 0,
        solution: 'Constructions requiring midpoint:\n• Perpendicular bisector (bisects segment)\n• Median (connects vertex to midpoint)\n• Centroid (uses medians)\n• Circumcenter (uses perpendicular bisectors)\n\nMidpoint construction is fundamental to many other constructions.'
      },
      {
        id: 27,
        question: 'To construct a rhombus, what is the minimum information needed?',
        options: ['One side length', 'Two side lengths', 'One angle', 'Diagonal lengths'],
        correctAnswer: 0,
        solution: 'Rhombus construction (all sides equal):\n1. Draw segment AB (one side)\n2. Draw circle centered at A with radius AB\n3. Draw circle centered at B with same radius\n4. Mark point C on one intersection\n5. Draw circle centered at C with same radius\n6. Mark point D where circles from A and C intersect\n7. Connect to form rhombus\n\nOnly one side length needed (all sides equal).'
      },
      {
        id: 28,
        question: 'What is the relationship between the angle bisector and the two sides of the angle?',
        options: ['Equidistant from both sides', 'Perpendicular to both sides', 'Parallel to both sides', 'Bisects both sides'],
        correctAnswer: 0,
        solution: 'Angle Bisector Theorem:\nAny point on the angle bisector is equidistant from the two sides of the angle.\n\nThis property is used in:\n• Incenter construction (equidistant from all three sides)\n• Inscribed circle construction\n\nAngle bisector creates equal perpendicular distances to sides.'
      },
      {
        id: 29,
        question: 'To construct a line parallel to line ℓ at a specific distance d, what should you construct?',
        options: ['Two perpendiculars at distance d', 'Copy angle at distance d', 'Bisect segment of length d', 'Draw circle with radius d'],
        correctAnswer: 0,
        solution: 'Parallel line at specific distance:\n1. Construct perpendicular to ℓ at any point\n2. Mark distance d on perpendicular\n3. Construct another perpendicular at distance d\n4. This line is parallel to ℓ at distance d\n\nAlternatively: Draw arcs of radius d from multiple points on ℓ and connect tangent line.'
      },
      {
        id: 30,
        question: 'Which construction is used to divide a segment into equal parts?',
        options: ['Parallel lines and transversals', 'Perpendicular bisectors', 'Angle bisectors', 'Concentric circles'],
        correctAnswer: 0,
        solution: 'Dividing segment into n equal parts:\n1. Draw ray from one endpoint at any angle\n2. Mark n equal distances on ray (any convenient length)\n3. Connect last point to other endpoint of segment\n4. Draw parallel lines through other marked points\n5. These divide the segment into n equal parts\n\nThis uses the Side-Splitter Theorem (parallel lines divide transversals proportionally).'
      }
    ]
  }
];